import defaultMetricGroup from './defaultMetricGroup';

export default function defaultSnapshotMetrics() {
  return {
    total: defaultMetricGroup({ includeSpan: true }),
    visible: defaultMetricGroup({ includeSpan: true }),
  };
}
